<script setup lang="ts">
/* Types */
import { Component } from '@/types/api/api-v3/product'

type Props = {
  component: Component
  border: boolean
}

const props = defineProps<Props>()

const isErrorImage = ref(false)

const imageUrl = computed(() => {
  if (!props.component?.image || isErrorImage.value) {
    return './no-image-category.webp'
  }

  return props.component.image
})
</script>

<template>
  <div class="component">
    <nuxt-img
      class="component__image"
      :src="imageUrl"
      :alt="component.name"
      @error="isErrorImage = true"
    />

    <h5 class="component__title">{{ component.name }}</h5>

    <p class="component__description">{{ component.description }}</p>
  </div>

  <div v-if="border" class="component__border" />
</template>

<style lang="scss" scoped>
$card-height: 206px;

.component__border {
  width: 1px;
  height: $card-height;
  margin: 0 8px;
  background-color: var(--ui-grey);
}

.component {
  width: 100%;
  max-width: 176px;
  height: $card-height;
  padding: 8px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:first-child {
    max-width: 164px;
  }

  &:hover {
    max-width: 280px;
    background-color: var(--ui-white);
    border-radius: 16px;
    box-shadow: var(--ui-card-shadow);
  }

  &__image {
    width: 81px;
    height: 50px;
    border-radius: 6px;
  }

  &__title {
    display: -moz-box;
    display: -webkit-box;
    width: 100%;
    margin-top: 8px;
    overflow: hidden;
    font-size: 14px;
    font-weight: 800;
    line-height: 18px;
    color: var(--ui-secondary);
    text-overflow: ellipsis;
    white-space: pre-wrap;
    -moz-box-orient: vertical;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-clamp: 2;
  }

  &__description {
    display: -moz-box;
    display: -webkit-box;
    width: 100%;
    margin-block-end: 0;
    margin-top: 6px;
    overflow: hidden;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    color: var(--ui-dark-grey);

    // для разных браузеров ставим ограничение в 5 строк видимости описания
    text-overflow: ellipsis;
    white-space: pre-wrap;
    -moz-box-orient: vertical;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    line-clamp: 5;
  }
}
</style>
